import React, { createContext, useContext } from "react";

const AxiosContext = createContext({});

export const useAxios = () => useContext(AxiosContext).client;

export const AxiosProvider = ({ children, client }) => {
  const value = { client };
  return (
    <AxiosContext.Provider value={value}>{children}</AxiosContext.Provider>
  );
};
